import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Button } from "src/components/Button";
import { ReactComponent as FiltersIcon } from "src/assets/icons/filters.svg";
import { filteringButtonsTrns } from "./trns";
import { ButtonVariants } from "../Button/types";

interface Props {
  className?: string;
  setIsOpen: (isOpen: boolean | ((isOpen: boolean) => boolean)) => void;
}

export const FilteringButton: FC<Props> = ({ className, setIsOpen }) => {
  const { t } = useTranslation();

  const toggleIsOpen = () => setIsOpen((prev) => !prev);

  return (
    <Button
      className={cn("gap-2 py-2 px-3", className)}
      variant={ButtonVariants.SECONDARY}
      onClick={toggleIsOpen}
    >
      <FiltersIcon className="fill-svg-purple-base" />
      <span>{t(filteringButtonsTrns.filters)}</span>
    </Button>
  );
};
